import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';

import { SearchResultCampaigns } from './types';

export type SearchResultCampaignsAction = SearchLoadFulfilledAction | SearchLoadMoreFulfilledAction;

const initialState: SearchResultCampaigns = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SearchResultCampaigns, SearchResultCampaignsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultCampaigns);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultCampaigns);
    default:
      return state;
  }
};

export default reducer;
